import {USER_ERROR, USER_REQUEST, USER_SUCCESS} from '../actions/user'
import {AUTH_LOGOUT} from '../actions/auth'
import Vue from 'vue'
import AuthService from "../../services/AuthService";
import {defineAbilitiesFor} from "../../util/abilities";


const state = {status: '', user: {}};

const getters = {
    getUser: state => state.user,
    isUserLoaded: state => !!state.user.firstName,
    isUserSuccess: state => state.status === 'success',
};

const actions = {
    [USER_REQUEST]: ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            commit(USER_REQUEST);
            AuthService.authInfo()
                .then(resp => {
                    if (resp) {
                        const payload = resp.data.payload;
                        window.dispatchEvent(new Event('resize'));
                        defineAbilitiesFor(payload.roles);
                        commit(USER_SUCCESS, payload);
                        resolve();
                    } else {
                        commit(USER_ERROR);
                        dispatch(AUTH_LOGOUT);
                    }
                })
                .catch(err => {
                    commit(USER_ERROR);
                    dispatch(AUTH_LOGOUT);
                    reject(err);
                });
        });
    },
};

const mutations = {
    [USER_REQUEST]: (state) => {
        state.status = 'loading'
    },
    [USER_SUCCESS]: (state, resp) => {
        state.status = 'success';
        Vue.set(state, 'user', resp)
    },
    [USER_ERROR]: (state) => {
        state.status = 'error'
    },
    [AUTH_LOGOUT]: (state) => {
        state.user = {}
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js